import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { ChatInboxModel, ChatSmsPackageModel } from '@/models'

export interface GetInboxesRequest {
  buildingId: number
}

export interface GetInboxesResponse {
  inboxes: ChatInboxModel[]
  smsPackage: ChatSmsPackageModel
}

export const getInboxesQueryKey = (data: GetInboxesRequest) => ['useGetInboxes', data]

export const getInboxes = async (params: GetInboxesRequest) => {
  const response = await authAPI.get<GetInboxesResponse>('/chat-inbox', {
    params,
  })
  return response.data
}

export interface UseGetInboxesProps {
  enabled?: boolean
}

export const useGetInboxes = (data: GetInboxesRequest, { enabled }: UseGetInboxesProps = {}) => {
  return useQuery({
    enabled,
    queryFn: () => getInboxes(data),
    queryKey: getInboxesQueryKey(data),
  })
}
